import React from 'react'
import { localized } from '@/decorators/localized'
import { RichTextEditor } from '@/components/richTextEditor'
import { Input } from 'reactstrap'
import Tooltip from '../Tooltip'
import { Button } from '@/components/button'
import isEnterPressed from '@/utils/isEnterPressed'
import CheckBox from '@/components/CheckBox'
import { visibilityTypes } from './CommentItem'
@localized()
class CommentInput extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      showRichTextEditor: false,
      answer: '',
      externalVisibility: false
    }
    this.showRteId = (props.id || new Date().getTime())
  }

  toggle = () => {
    this.setState({
      showRichTextEditor: !this.state.showRichTextEditor
    })
  }

  addComment = () => {
    if (this.props.disabled === true || !this.hasText()) { return }
    const visibility = this.state.externalVisibility ? visibilityTypes.EXTERNAL : visibilityTypes.INTERNAL
    this.props.onCommentCreated({ text: this.state.answer, parentId: this.props.parentId, visibility })
  }
  isHtmlEmpty = () => this.editor && typeof this.editor.isEmpty === 'function' ? this.editor.isEmpty() : true
  hasText = () => this.state.showRichTextEditor ? !this.isHtmlEmpty() : this.state.answer.length > 0

  handleKeyDown = (e) => {
    if (isEnterPressed(e)) { this.addComment() }
  }
  renderEditor (localize) {
    if (this.state.showRichTextEditor) {
      return <React.Fragment>
        {this.props.showExternalVisibilityCheckbox && <CheckBox
          id={`external-checkbox--${this.showRteId}`}
          className='external-checkbox'
          label={localize('Common.ExternalTooltip')}
          checked={this.state.externalVisibility}
          onChange={value => this.setState({ externalVisibility: value })}
        />}
        <RichTextEditor ref={ref => { this.editor = ref }} value={this.state.answer} onChange={answer => this.setState({ answer })} />
      </React.Fragment>
    }

    return (<Input bsSize='lg' onKeyDown={this.handleKeyDown} onChange={event => this.setState({ answer: event.target.value })} />)
  }
  render () {
    const { localize, disabled } = this.props
    let wrapClass = this.state.showRichTextEditor ? 'comment-input comment-input--rich-text-editor' : 'comment-input'
    const sendButtonDisabled = (disabled || !this.hasText())
    wrapClass = this.props.size === 'lg' ? `${wrapClass} comment-input--lg` : wrapClass
    return (
      <div className={wrapClass}>
        <Button disabled={disabled} onClick={this.toggle} id={'rich-text-show--' + this.showRteId} icon='pen' iconOnly className='comment-input__switch' />
        <Tooltip placement='top' target={'rich-text-show--' + this.showRteId}>{localize('Common.ShowRichTextEditor')}</Tooltip>
        {this.renderEditor(localize)}
        <Button disabled={sendButtonDisabled} iconOnly icon='send' className='comment-input__submit' onClick={this.addComment} />
      </div>
    )
  }
}

export default CommentInput



// WEBPACK FOOTER //
// ./src/components/comments/CommentInput.js